import React, { useEffect, useState } from 'react'
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard'
import { Grid, Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'
import * as R from 'ramda'

import { COPY_TO_CLIPBOARD_TOOLTIP_HIDING_DELAY } from '../constants/defaults'
import i18n from '../locales/i18n'
import { ClassesType } from '../types'
import ButtonWithLoader from './buttons/ButtonWithLoader'
import LinkButton from './buttons/LinkButton'

const useStyles = makeStyles(
  () => ({
    link: {},
    button: {},
  }),
  { name: 'CopyToClipboard' },
)

export interface CopyToClipboardProps {
  readonly classes?: ClassesType<typeof useStyles>
  readonly isButton?: boolean
  readonly label?: React.ReactNode
  readonly onClick?: () => void
  readonly text: string
}

const CopyToClipboard = ({
  text,
  label,
  isButton = false,
  onClick = R.F,
  classes: classesProp,
}: CopyToClipboardProps) => {
  const classes = useStyles({ classes: classesProp })
  const copyToClipBoardLabel =
    label || i18n.t<string>('Common:COPY_TO_CLIPBOARD')

  const [copyToClipboardTooltipOpen, setCopyToClipboardTooltipOpen] =
    useState<boolean>(false)
  const [tooltipTimeout, setTooltipTimeout] = useState<number>()

  const toggleTooltipVisibility = (newState: boolean) => {
    setCopyToClipboardTooltipOpen(newState)
  }

  const copyToClipBoard = () => {
    toggleTooltipVisibility(true)
    const timeoutId: number = window.setTimeout(
      toggleTooltipVisibility,
      COPY_TO_CLIPBOARD_TOOLTIP_HIDING_DELAY,
      false,
    )
    setTooltipTimeout(timeoutId)
    onClick()
  }

  useEffect(() => () => clearTimeout(tooltipTimeout), [tooltipTimeout])

  return (
    <ReactCopyToClipboard text={text}>
      <Tooltip
        disableFocusListener
        disableHoverListener
        disableTouchListener
        PopperProps={{
          disablePortal: true,
        }}
        open={copyToClipboardTooltipOpen}
        title={i18n.t<string>('Common:COPIED')}
      >
        <Grid onMouseLeave={() => toggleTooltipVisibility(false)}>
          {isButton ? (
            <ButtonWithLoader
              className={classes.button}
              onClick={copyToClipBoard}
            >
              {copyToClipBoardLabel}
            </ButtonWithLoader>
          ) : (
            <LinkButton className={classes.link} onClick={copyToClipBoard}>
              {copyToClipBoardLabel}
            </LinkButton>
          )}
        </Grid>
      </Tooltip>
    </ReactCopyToClipboard>
  )
}
export default CopyToClipboard
